import { addBreadcrumb } from './breadcrumbs.js';
import { getCurrentScope, withScope, getClient as _getClient, getIsolationScope } from './currentScopes.js';
import { captureEvent, setUser, setTags, setTag, setExtra, setExtras, setContext, startSession, endSession } from './exports.js';

/**
 * This is for legacy reasons, and returns a proxy object instead of a hub to be used.
 *
 * @deprecated Use the methods directly from the top level Sentry API (e.g. `Sentry.withScope`)
 * For more information see our migration guide for
 * [replacing `getCurrentHub` and `Hub`](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 * usage
 */
// eslint-disable-next-line deprecation/deprecation
function getCurrentHubShim() {
  return {
    bindClient: function bindClient(client) {
      var scope = getCurrentScope();
      scope.setClient(client);
    },
    withScope: withScope,
    getClient: function getClient() {
      return _getClient();
    },
    getScope: getCurrentScope,
    getIsolationScope: getIsolationScope,
    captureException: function captureException(exception, hint) {
      return getCurrentScope().captureException(exception, hint);
    },
    captureMessage: function captureMessage(message, level, hint) {
      return getCurrentScope().captureMessage(message, level, hint);
    },
    captureEvent: captureEvent,
    addBreadcrumb: addBreadcrumb,
    setUser: setUser,
    setTags: setTags,
    setTag: setTag,
    setExtra: setExtra,
    setExtras: setExtras,
    setContext: setContext,
    getIntegration: function getIntegration(integration) {
      var client = _getClient();
      return client && client.getIntegrationByName(integration.id) || null;
    },
    startSession: startSession,
    endSession: endSession,
    captureSession: function captureSession(end) {
      // both send the update and pull the session from the scope
      if (end) {
        return endSession();
      }

      // only send the update
      _sendSessionUpdate();
    }
  };
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */
// eslint-disable-next-line deprecation/deprecation
var getCurrentHub = getCurrentHubShim;

/**
 * Sends the current Session on the scope
 */
function _sendSessionUpdate() {
  var scope = getCurrentScope();
  var client = _getClient();
  var session = scope.getSession();
  if (client && session) {
    client.captureSession(session);
  }
}
export { getCurrentHub, getCurrentHubShim };